import * as DomTypeUtils from '@packages/systems/core/utils/DomTypeUtils';

import type {Context} from '../types';

// Remove legacy navbar data - see https://github.com/webflow/webflow/issues/7976
export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;
  const {data = {}} = jsonNode;

  return {
    needed:
      DomTypeUtils.isNavbarWrapper(data) &&
      data.attr &&
      data.attr['data-contain'],
    logData: {
      msg: 'navBarWrapper with data-contain attr',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      // eslint-disable-next-line webflow/no-delete
      delete data.attr['data-contain'];
    },
  };
};
